import { useEmbedFeedStore } from '@core/widgets/embedFeed/store';
/**
 * Hoos responsible for resolving current autoplay video id of Grid
 * @return The encoded_id of the video should autoplay. Null if no video can autoplay
 *     either no eligible in viewport or other content-blocking autoplay, i.e. opened player
 */
export const useGridAutoplayVideoId = (props) => {
    const { isPlayingCurrentContent } = props;
    const player = useEmbedFeedStore((state) => state.player);
    const autoplayId = useEmbedFeedStore((state) => state.autoplayId);
    if (isPlayingCurrentContent || player.isOpen) {
        return null;
    }
    return autoplayId;
};
